import { call, put, takeEvery } from "redux-saga/effects";
import { ICoSo } from "../../../model/respone/category/ICoSo";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmCoSoActionIds,
  IDmCoSoActionTypes,
} from "../../action-types/category/IDmCoSoActions";
import { rootActions } from "../../actions/rootActions";
import { coSoApi } from "./../../../api/category/coSoApi";
const mainAction = rootActions.category.coso;

export function* coSoSaga(): any {
  yield takeEvery(eDmCoSoActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmCoSoActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmCoSoActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(coSoApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmCoSoActionTypes): any {
  let res: IBaseRespone = yield call(coSoApi.SelectAll);
  let payload = action.payload as ICoSo;
  if (payload.id_co_so > 0) {
    res = yield call(coSoApi.Update, payload);
  } else {
    payload = {
      ...payload,
      ten_co_so_en: "",
      ten_co_so_viet_tat: "",
      ten_co_so_viet_tat_en: "",
      co_quan_chu_quan: "",
      dien_thoai: "",
      so_fax: "",
      email: "",
      website: "",
      nam_thanh_lap: "",
      thoi_gian_bat_dau_dao_tao: "",
      loai_hinh_dao_tao: 0,
      loai_hinh_dao_tao_chinhQuy: false,
      loai_hinh_dao_tao_khongchinhquy: false,
      loai_hinh_dao_tao_tuxa: false,
      loai_hinh_dao_tao_lienKetdaotaonuocngoai: false,
      loai_hinh_dao_tao_lienketdaotaotrongnuoc: false,
      loai_hinh_dao_tao_khac: "",
      la_co_so_chinh: false,
      isngoai_tinh: false,
      isco_so_thuc_tap: false,
      mo_ta_co_so: "",
    };
    res = yield call(coSoApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmCoSoActionTypes): any {
  const res: IBaseRespone = yield call(
    coSoApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
